<!--
 * @Author: wangwenshuai 644586996@qq.com
 * @Date: 2022-08-12 09:33:10
 * @LastEditors: wangwenshuai 644586996@qq.com
 * @LastEditTime: 2023-11-10 14:16:15
 * @FilePath: \dbarsdgs\src\components\DataDetails\Details\DataInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="DataInfo">
    <div class="DataInfo_box">
      <div>
        <i class="iconfont icon-shijian1"></i>
      </div>
      <div class="text_box">
        <p>{{ DataInfo.createTime }}</p>
        <p>{{$t('DataDetails.latestUpdate')}}</p>
      </div>
    </div>
    <div class="DataInfo_box">
      <div>
        <i class="iconfont icon-odbc-full"></i>
      </div>
      <div class="text_box">
         <p v-if="DataInfo.dataId == 301">74TB</p>
        <p v-else-if="DataInfo.dataId == 313">263 TB</p>
        <p v-else>{{ DataInfo.storageCapacity }}</p>
        <p>{{$t('DataDetails.storageVolume')}}</p>
      </div>
    </div>
    <div class="DataInfo_box">
      <div>
        <i class="iconfont icon-haoyou"></i>
      </div>
      <div class="text_box">
        <p>{{ DataInfo.visits }}</p>
        <p>{{$t('DataDetails.visits')}}</p>
      </div>
    </div>
    <div class="DataInfo_box">
      <div>
        <i class="iconfont icon-xiazai-wenjianxiazai-14"></i>
      </div>
      <div class="text_box">
        <p>{{ DataInfo.downloads }}</p>
        <p>{{$t('DataDetails.downloads')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["DataInfo"],
};
</script>

<style lang="scss" scoped>
.DataInfo {
    margin: 24px 0;
  display: flex;
  justify-content: space-around;
  padding: 26px 20px;
  border: 1px solid #f7f9fc;
  border-radius: 8px;
  .DataInfo_box:nth-child(1) i{
        color:rgba(197,167,238,1);
        font-size: 36px;
    }
      .DataInfo_box:nth-child(2) i{
        color:rgba(3,154,255,1);

    }
      .DataInfo_box:nth-child(3) i{
        color:rgba(222,152,237,1);
 
    }
      .DataInfo_box:nth-child(4) i{
        color:rgba(109,193,87,1);

    }
  .DataInfo_box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    i{
        margin-right: 8px;
        font-size: 34px;
    }
  
    .text_box {
        color:rgba(153, 153, 153, 1);
        font-size: 14px;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>